export default __webpack_public_path__ + "static/media/com-foto2.d733c086.jpg";